import React from "react";
import { motion } from "framer-motion";
import { Button, Typography } from "@material-tailwind/react";
import { MdContactMail } from "react-icons/md";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";

import { HiAcademicCap } from "react-icons/hi";
import Education from "./Education";

const About = () => {
  const data = [
    {
      label: "Education",
      value: "Education",
      icon: HiAcademicCap,
      desc: <Education />,
    },
  ];

  return (
    <section id="about" className=" w-full md:min-h-[75vh]">
      <div className="pt-10 flex flex-col md:flex-row items-center justify-center lg:mx-52 md:pt-20">
        <motion.Typography
          initial={{ opacity: 0, y: 100 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.7 }}
          className=" text-justify font-serif m-5 md:m-0 p-6 md:ml-5 mt-5 md:w-1/2 bg-white rounded-md shadow-2xl drop-shadow-sm backdrop-blur-md bg-opacity-20  "
        >
          <Typography className=" text-center mt-2 mb-5 border-b-2 border-light-blue-500">
            About Me
          </Typography>
          Hi! I'm an engineering graduate with hands-on experience in  <span className="font-semibold mx-2 decoration-light-green-600">Full-stack web development</span>, specializing in React.js, TypeScript, and Node.js. I have a diverse skill set, including proficiency in
          <span className="font-semibold mx-2 decoration-light-green-600">
            Git, GitLab, Postman, Jira.
          </span>
          <br />
          I am eager to apply my hands-on experience in the industry and work on
          impactful projects. I’m especially interested in roles that involve
          collaboration within a team, where I can learn from others while
          contributing my technical skills.
          <br />
          <br />
          Beyond my technical expertise, I take pride in my involvement in
          social work. Actively leading various social service projects as a member of the
          <span className="font-semibold mx-2 decoration-light-blue-600">
            CITADEL,
          </span>
          team, contributing to community development and education.
          <br />
          I'm excited to explore opportunities where I can merge my passion for
          technology and social impact. Let’s connect and work together to
          create innovative solutions!
          <br />
          <div className="flex items-center justify-center gap-2">
            <a href="#contact">
              <Button
                variant="gradient"
                color="light-blue"
                fullWidth
                className="mt-5 flex items-center gap-2"
              >
                <MdContactMail className="text-white text-lg animate-pulse" />
                Contact
              </Button>
            </a>
          </div>
        </motion.Typography>
        <motion.div
          initial={{ opacity: 0, y: -100 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.7 }}
          className="flex flex-col items-center min-h-[80vh] lg:ml-10 py-10"
        >
          <Tabs
            value={data[0].value}
            className="w-full flex items-center flex-col my-7"
          >
            <TabsHeader className="w-80 flex items-center mb-7 drop-shadow-2xl">
              {data.map(({ label, value, icon }) => (
                <Tab key={value} value={value}>
                  <div className="flex items-center gap-2 ">
                    {React.createElement(icon, { className: "w-5 h-5" })}
                    {label}
                  </div>
                </Tab>
              ))}
            </TabsHeader>
            <TabsBody
              // animate={{
              //   initial: { y: 100 },
              //   mount: { y: 0 },
              //   unmount: { y: 100 },
              // }}
              className="flex justify-center"
            >
              {data.map(({ value, desc }) => (
                <TabPanel key={value} value={value}>
                  {desc}
                </TabPanel>
              ))}
            </TabsBody>
          </Tabs>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
